import Swiper, { Navigation } from "swiper";

const setAboutSlider = () => {
  const target = document.getElementById('js-about-slider')
  if (!target) return false;

  const slides = target.querySelectorAll('.swiper-slide');
  if (slides.length > 1) {
    const prev = document.querySelector('.about-slider-nav__prev'),
      next = document.querySelector('.about-slider-nav__next');
    const swiper = new Swiper(target, {
      modules: [Navigation],
      loop: true,
      slidesPerView: 'auto',
      centeredSlides: false,
      speed: 400,
      navigation: {
        prevEl: prev,
        nextEl: next,
      }
    });

    prev?.classList.add('is-show');
    next?.classList.add('is-show');
  }

  target.classList.add('is-init')
};

export default setAboutSlider;